import { useState, useEffect } from "react";
function getFallbackHeight(): number {
  if (typeof window === "undefined") return 840;
  if (window.innerWidth < 768) return 760;
  if (window.innerWidth < 1024) return 800;
  return 840;
}
export default function Estimator() {
  const [iframeHeight, setIframeHeight] = useState<number>(840);
  useEffect(() => {
    const fallback = getFallbackHeight();
    setIframeHeight(fallback);
    const handleMessage = (event: MessageEvent) => {
      if (typeof event.origin === "string" && !event.origin.includes("roofr.com")) {
        return;
      }
      let parsedHeight: number | null = null;
      if (typeof event.data === "number") {
        parsedHeight = event.data;
      } else if (typeof event.data === "string") {
        const num = Number(event.data);
        if (!isNaN(num) && num > 0) {
          parsedHeight = num;
        } else {
          try {
            const parsed = JSON.parse(event.data);
            if (parsed && typeof parsed === "object") {
              const h = parsed.height ?? parsed.frameHeight ?? parsed.contentHeight ?? parsed.data?.height ?? parsed.data?.frameHeight;
              if (typeof h === "number") parsedHeight = h;else if (typeof h === "string" && !isNaN(Number(h))) parsedHeight = Number(h);
            }
          } catch {
            // ignore non-JSON messages
          }
        }
      } else if (typeof event.data === "object" && event.data !== null) {
        const d = event.data as Record<string, any>;
        const h = d.height ?? d.frameHeight ?? d.contentHeight ?? d.data?.height ?? d.data?.frameHeight ?? d.data?.contentHeight;
        if (typeof h === "number") parsedHeight = h;else if (typeof h === "string" && !isNaN(Number(h))) parsedHeight = Number(h);
      }
      if (parsedHeight && parsedHeight > 0) {
        setIframeHeight(Math.max(parsedHeight, 400));
      }
    };
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);
  return <section id="roofestimatorembed" data-nav="light" className="bg-background text-foreground py-6 md:py-8 px-6 md:px-10 lg:px-16">
      <div className="max-w-[1240px] mx-auto flex justify-center">
        <div className="w-full max-w-[800px] transition-[height] duration-300" style={{
        height: iframeHeight
      }}>
          <iframe src="https://app.roofr.com/instant-estimator/e8748161-cef6-41c6-9605-25fbe0a37f19/MetalLineExteriorsCorp" width="800" height={iframeHeight} title="Instant Roof Estimator" className="w-full border-0 rounded-sm transition-[height] duration-300" style={{
          height: iframeHeight
        }} />
        </div>
      </div>
    </section>;
}